import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoadingSpinner from "../components/common/LoadingSpinner";
import useCustomIdleTimer from "../hooks/useCustomIdleTimer";
import { persistor } from "../services/redux/store";
import { useDispatch } from "react-redux";

const AuthRoutes = () => {
  const { isAuthenticated, isInitialized } = useAuth();
  const dispatch = useDispatch();

  const handleUserIdle = async () => {
    dispatch({ type: 'USER_LOGOUT' });  // after logout api calls and navigation was working, so this is the fix for that 
      if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "SESSION_TIME_OUT" })
        );
      }
    sessionStorage?.clear();
    await persistor.purge(); // clearing redux store
    window.location.href = "/session-timeout";
  };

  const timer = useCustomIdleTimer(
    handleUserIdle,
    process.env.REACT_APP_IDLE_SESSION_TIME || "2h"
  );

  // Show loading while initializing authentication
  if (!isInitialized) {
    return <LoadingSpinner message="Checking authentication..." />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthRoutes;
